import Homepage from "../dom/pages/Homepage";
import Main from "../dom/pages/Main";
import ExternalLink from "./pages/ExternalLink";


/* Functions */
export const DomContent = () => {
  Homepage();
  Main();
  ExternalLink();
};

export default DomContent;
